module.exports = __webpack_public_path__ + "img/stakebodyatten_stopped.b1cbef28.svg";